module.exports = __webpack_public_path__ + "img/0020.00d73f2b.png";